import { render, staticRenderFns } from "./LatestMessages.vue?vue&type=template&id=13cde4de"
import script from "./LatestMessages.vue?vue&type=script&lang=js"
export * from "./LatestMessages.vue?vue&type=script&lang=js"
import style0 from "./LatestMessages.vue?vue&type=style&index=0&id=13cde4de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports